import moment from "moment";

import { getUtcDateFormatted } from "./getUtcDateFormatted";

export function getDateFormatted({ date, hour }: { date: string; hour?: number; }): string {
    return getUtcDateFormatted(moment(date).clone().set({ hour, minute: 0 }));
}
